import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DualLockingComponent } from './dual-locking/dual-locking.component';
import { DualLockingAdminComponent } from './dual-locking-admin/dual-locking-admin.component';
import { DualLockingMISComponent } from './dual-locking-mis/dual-locking-mis.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpModule } from '../otp.module';

@NgModule({
  declarations: [DualLockingComponent, DualLockingAdminComponent , DualLockingMISComponent, ] ,
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule,
    OtpModule],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class DualModule { }
